import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IModeleRapportState {
  modelesRapport: IModeleRapport[];
  filteredModelesRapport: IModeleRapport[];
  planItemToEdit: IPlanItem | undefined;
  // hideListeModele: boolean;
}

export interface IModeleRapport {
  idModeleRapport: string;
  libelleModeleRapport: string;
  planModeleRapport: IPlanItem[];
  status: number;
  revision:number;
  modificationMiseEnLigne:number;
  canGeneret:number;
}

export interface IPlanItem {
  index: number;
  title: string;
  name: string;
  type: ITypePlanRapportItem;
  content: string;
  instructions: string;
  typographie: ITypographie;
  isChecked:boolean;
}

export type ITypePlanRapportItem = "textarea" | "p" | "array" | "" | "radio" | "checkBox" | "comboBox" | "input";

export type ITypographie =
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "caption"
  | "body1"
  | "body2"
  | ""
  | undefined;

const initialState: IModeleRapportState = {
  modelesRapport: [],
  filteredModelesRapport: [],
  planItemToEdit: undefined,
  // hideListeModele: true,
};

export const modeleRapportSlice = createSlice({
  name: "modeleRapport",
  initialState: initialState,
  reducers: {
    setModelesRapport: (state, action: PayloadAction<IModeleRapport[]>) => {
      state.modelesRapport = action.payload;
    },

    setFilteredModelesRapport: (
      state,
      action: PayloadAction<IModeleRapport[]>
    ) => {
      state.filteredModelesRapport = action.payload;
    },

    addModeleRapport: (state, action: PayloadAction<IModeleRapport>) => {
      state.modelesRapport.push(action.payload);
      state.filteredModelesRapport.push(action.payload);
    },

    updateModeleRapport: (state, action: PayloadAction<IModeleRapport>) => {
      const newModeleRapport = state.modelesRapport.map((i: IModeleRapport) =>
        i.idModeleRapport === action.payload.idModeleRapport
          ? action.payload
          : i
      );
      const filteredNewModeleRapport = state.filteredModelesRapport.map(
        (i: IModeleRapport) =>
          i.idModeleRapport === action.payload.idModeleRapport
            ? action.payload
            : i
      );
      state.modelesRapport = newModeleRapport;
      state.filteredModelesRapport = filteredNewModeleRapport;
    },

    deleteModelesRapport: (
      state,
      action: PayloadAction<{ idModeleRapport: string }>
    ) => {
      state.modelesRapport = state.modelesRapport.filter(
        (modeleRapport) =>
          modeleRapport.idModeleRapport !== action.payload.idModeleRapport
      );
      state.filteredModelesRapport = state.filteredModelesRapport.filter(
        (modeleRapport) =>
          modeleRapport.idModeleRapport !== action.payload.idModeleRapport
      );
    },

    setPlanItemToEdit: (state, action: PayloadAction<IPlanItem>) => {
      state.planItemToEdit = action.payload;
    },

    // setHideListeModele: (state, action: PayloadAction<boolean>) => {
    //   state.hideListeModele = action.payload;
    // },

    updateModelesRapportApresEnvoieEnLigne: (
      state,
      action: PayloadAction<IModeleRapport[]>
    ) => {
      const newModelesRapport = state.modelesRapport.map(
        (item: IModeleRapport) => {
          const indexModeleRapport = action.payload.findIndex(
            (payloadModele: IModeleRapport) =>
              item.idModeleRapport === payloadModele.idModeleRapport
          );
          if (indexModeleRapport < 0) {
            return item;
          } else {
            return action.payload[indexModeleRapport];
          }
        }
      );

      const filteredNewModeleRapport = state.filteredModelesRapport.map(
        (item: IModeleRapport) => {
          const indexModeleRapport = action.payload.findIndex(
            (payloadModele: IModeleRapport) =>
              item.idModeleRapport === payloadModele.idModeleRapport
          );
          if (indexModeleRapport < 0) {
            return item;
          } else {
            return action.payload[indexModeleRapport];
          }
        }
      );

      state.modelesRapport = newModelesRapport;
      state.filteredModelesRapport = filteredNewModeleRapport;
    },
  },
});

export const {
  setModelesRapport,
  updateModeleRapport,
  deleteModelesRapport,
  addModeleRapport,
  setPlanItemToEdit,
  // setHideListeModele,
  updateModelesRapportApresEnvoieEnLigne,
  setFilteredModelesRapport,
} = modeleRapportSlice.actions;

export default modeleRapportSlice.reducer;
